
export default function($) {
  const partnersSwiper = new Swiper('.js-partners-slider', {
    slidesPerView: 2,
    spaceBetween: 16,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 6,
      },
      1280: {
        slidesPerView: 8,
      }
    }
  });
}
